import React from 'react';
import styles from './TestimonialsSection.module.scss';
import SectionBadge from '../components/SectionBadge';
import HorizontalTestimonials from '../../../Components/Testimonials/HorizontalTestimonials';

const TestimonialsSection = () => {
  return (
    <section className={styles.testimonials}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionBadge>Why they switched to Vocable</SectionBadge>
          <h2 className={styles.headline}>
            Join 10,000+ creators and businesses growing their channels with Vocable
          </h2>
        </div>

        <HorizontalTestimonials
          senjaApiKey="O22b0Cqtm3MwiwC0fqMfOc3vmbJW"
          speed={300}
          limit={1000}
          minRating={0}
          enableLengthFiltering={true}
          minLength={200}
          maxLength={300}
          hideHeader={true}
        />
      </div>
    </section>
  );
};

export default TestimonialsSection;
